import { ToggleButton } from '@mui/material';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormFieldset } from 'src/shared/components/form/formFieldset';
import { StyledToggleButtonGroup } from 'src/shared/components/organisms/styledToggleButtonGroup';
import ConsoleHelper from 'src/shared/functions/consoleHelper';

type MemberAdvancedSearchExclusiveToggleButtonProps = {
  nameProp: string;
  label: string;
  truthyLabel: string;
  falsyLabel: string;
};

export const MemberAdvancedSearchExclusiveToggleButton = (props: MemberAdvancedSearchExclusiveToggleButtonProps) => {
  const { nameProp, label, truthyLabel, falsyLabel } = props;
  const { setValue, watch } = useFormContext();
  const { t } = useTranslation(['member']);

  const [toggleState, setToggleState] = useState('');

  const handleChange = (event: React.MouseEvent<HTMLElement>, newToggleState: string) => {
    setToggleState(newToggleState);
    setValue(nameProp, newToggleState);
  };

  const values = watch(nameProp);

  React.useEffect(() => {
    ConsoleHelper.log('setToggleState', values, nameProp);
    setToggleState(values);
  }, [nameProp, values]);

  return (
    <FormFieldset legend={label} noPadding>
      <StyledToggleButtonGroup value={toggleState} exclusive onChange={handleChange} color='primary' size='small'>
        <ToggleButton value='true' key='val_true'>
          {t(truthyLabel)}
        </ToggleButton>
        <ToggleButton value='false' key='val_false'>
          {t(falsyLabel)}
        </ToggleButton>
      </StyledToggleButtonGroup>
    </FormFieldset>
  );
};
